"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePlaylist = void 0;
var _reactSdk = require("@100mslive/react-sdk");
var usePlaylist = function usePlaylist(type) {
  var isAudioPlaylist = type === _reactSdk.HMSPlaylistType.audio;
  var selector = isAudioPlaylist ? _reactSdk.selectAudioPlaylist : _reactSdk.selectVideoPlaylist;
  var active = (0, _reactSdk.useHMSStore)(selector.selectedItem);
  var selection = (0, _reactSdk.useHMSStore)(selector.selection);
  var playlist = (0, _reactSdk.useHMSStore)(selector.list);
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var playlistAction = isAudioPlaylist ? hmsActions.audioPlaylist : hmsActions.videoPlaylist;
  return {
    active: active,
    hasNext: selection.hasNext,
    hasPrevious: selection.hasPrevious,
    actions: playlistAction,
    list: playlist
  };
};
exports.usePlaylist = usePlaylist;